import api from "./api";

/**
 * Record a print/export event for audit history.
 * Failure is silently logged (does not break the UX flow).
 *
 * @param {"single_pdf"|"single_print"|"a4_pdf"|"a4_print"} kind
 * @param {string[]} employeeIds
 * @param {number} [count]
 */
export const recordPrintEvent = async (kind, employeeIds, count) => {
    try {
        await api.post("/print-events", {
            kind,
            employee_ids: employeeIds,
            count: count ?? employeeIds.length,
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("recordPrintEvent failed (non-fatal):", e?.message);
    }
};
